import { Component } from '@angular/core';

@Component({
  selector: 'tandc-master-side-bar',
  templateUrl: './master-side-bar.component.html',
  styleUrls: ['./master-side-bar.component.scss']
})
export class MasterSideBarComponent {
  isSidebarButtonToggled = false;
  bodyTag = document.body;


  constructor() {}

  ngOnInit() {
    const sidebar = document.querySelector('.sidebar-main') as HTMLElement;
    const submenu = document.querySelector('#pageSubmenu') as HTMLElement;
    const toggleLink = document.querySelector('.site_sidebar-main_link') as HTMLElement;

    if (sidebar && submenu && toggleLink) {
      sidebar.classList.add('active-sidebar');
      submenu.classList.add('show'); 
      toggleLink.setAttribute('aria-expanded', 'true');
    }
  }

  toggleClass(){
  }
  
  toggleSideBar() { 
    const sidebar = document.getElementById('sidebar');
    const mainContainer = document.getElementById('mainContainer');
    
    if (sidebar !== null && mainContainer!=null) {
      if (!this.isSidebarButtonToggled) {
        sidebar.classList.add('sidebar--collapse');  
        mainContainer.classList.add('main-container--expand');
        this.bodyTag.classList.add("body-sidebar-collapsed");  
        this.isSidebarButtonToggled = true;
  
      } else {  
        sidebar.classList.remove('sidebar--collapse');  
        mainContainer.classList.remove('main-container--expand');
        this.bodyTag.classList.remove("body-sidebar-collapsed");  
        this.isSidebarButtonToggled = false;  
      }
    }   
  
  }
}
